import React from 'react';
import { Manager, Reference } from 'react-popper';
import ErrorBoundary from '../ErrorBoundary';
export var TooltipManager = function (_a) {
    var renderReference = _a.renderReference, children = _a.children;
    return (React.createElement(ErrorBoundary, null,
        React.createElement(Manager, null,
            React.createElement(Reference, null, renderReference),
            children)));
};
TooltipManager.displayName = 'TooltipManager';
export default TooltipManager;
//# sourceMappingURL=TooltipManager.js.map